import * as TYPE from "../../constants";

const initialState = {
  loading: false,
  shipAddresses: [],
  stateOptions: [],
  error: "",
};

export const shippingAddListReducer = (state = initialState, action) => {
  switch (action.type) {
    case TYPE.GET_SHIPPING_ADD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case TYPE.GET_SHIPPING_ADD_SUCCESS:
      return {
        ...state,
        loading: false,
        shipAddresses: action.payload,
      };
    case TYPE.SET_SHIPPING_DATA:
      return {
        ...state,
        loading: false,
        ...action.payload,
      };
    case TYPE.GET_SHIPPING_ADD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
